import React, { useState } from 'react';
import { css } from '@emotion/core';
import { useHeightResizePostMessage } from 'client/hooks/useHeightResizePostMessage';
import EditorCollage from 'editor/components/Gallery/SettingPreviews/Collage/EditorCollage';
import Collage from 'ugc/components/ugcGallery/collage/Collage';
import ButtonViewMore from 'ugc/components/ugcGallery/montage/ButtonViewMore';
import Loading from 'client/components/Loading';

export default function CollageContainer({ config, editor = false, buttonClickLink }) {
    const [isInit, setIsInit] = useState(false);
    const { buttonSettings } = config;
    const { isShowButton, maskColor } = buttonSettings;
    const clientBodyRef = useHeightResizePostMessage({ useMaxSize: true });

    return (
        <>
            {!editor && !isInit && <Loading />}
            <div ref={clientBodyRef} css={containerStyle(editor, isInit)}>
                {editor ? <EditorCollage /> : <Collage setIsInit={setIsInit} />}
                <div css={buttonContainerStyle(maskColor)}>
                    {isShowButton && (
                        <a href={buttonClickLink} target="_blank" rel="noreferrer">
                            <ButtonViewMore config={config?.buttonSettings} />
                        </a>
                    )}
                </div>
            </div>
        </>
    );
}

const containerStyle = (editor, isInit) => css`
    padding: 16px 0 0 0;
    overflow: hidden;
    position: relative;
    ${'' /* min-height: 760px;
    max-height: 880px; */}
    height:100%;
    ${!editor && !isInit && `opacity:0;`}
`;

const buttonContainerStyle = maskColor => css`
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -8px;
    justify-content: center;
    align-items: center;
    display: flex;
    max-height: 168px;
    height: 100%;
    z-index: 2;
    background: linear-gradient(0deg, ${maskColor} 28.27%, rgba(250, 255, 0, 0) 94.35%);
`;
